<template>
  <el-dialog
    title="地图选点"
    :visible.sync="dialogMapVisible"
    width="1400px"
    top="10vh"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="select">
      <div style="width: 90px">搜索地址</div>
      <el-select
        v-model="selectValue"
        filterable
        remote
        size="small"
        reserve-keyword
        placeholder="请输入地址搜索"
        :remote-method="handleSearch"
        :loading="loading"
        @change="handleSelect"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item"
        >
          <div>
            <div>{{ item.name }}</div>
            <small style="color: #999">{{ item.address }}</small>
          </div>
        </el-option>
      </el-select>
    </div>
    <div class="map-container">
      <div id="container" class="map"></div>
    </div>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
window._AMapSecurityConfig = {
  securityJsCode: "e184bf846c4427f3d414d762b64e13b5",
};
export default {
  name: "MapPickerDialog",
  props: {
    dialogMapVisible: { type: Boolean, default: false },
    address: Object,
  },
  data() {
    return {
      map: null,
      marker: null,
      placeSearch: null,
      selectValue: null,
      options: [],
      loading: false,
      form: {
        location: "",
        lng: "",
        lat: "",
      },
    };
  },
  watch: {
    dialogMapVisible(val) {
      if (val) {
        this.$nextTick(async () => {
          if (!this.map) {
            await this.initMap();
          }
          const { lng, lat } = this.address;
          if (lng && lat) {
            Object.assign(this.form, this.address);
            console.log(lng, lat);
            this.marker.setPosition([lng, lat]);
            this.map.add(this.marker);
            this.map.setCenter([lng, lat]);
          } else {
            if (this.map) {
              this.map.setCenter([116.397428, 39.90923]);
            }
          }
        });
      }
    },
  },
  methods: {
    handleClose() {
      this.options = [];
      this.placeSearch = null;
      this.selectValue = null;
      this.form = { location: "", lng: "", lat: "" };
      this.map.remove(this.marker);

      this.$emit("update:dialogMapVisible", false);
    },
    async initMap() {
      await AMapLoader.load({
        key: "ddf60f503491e1cffdc31b19322e9f4c",
        version: "2.0",
        plugins: [
          "AMap.Scale",
          "AMap.Geolocation",
          "AMap.PlaceSearch",
          "AMap.AutoComplete",
          "AMap.Geocoder",
        ],
      })
        .then((AMap) => {
          const that = this;
          that.map = new AMap.Map("container", {
            viewMode: "2D",
            // mapStyle: 'amap://styles/whitesmoke',
            center: [116.397428, 39.90923],
            animateEnable: false,
          });
          that.auto = new AMap.AutoComplete({
            city: "全国",
          });
          that.placeSearch = new AMap.PlaceSearch({
            autoFitView: false,
            extensions: "base",
          });
          const geocoder = new AMap.Geocoder();
          that.marker = new AMap.Marker({ zIndex: 1000 });
          that.map.on("click", function (e) {
            const { lat, lng } = e.lnglat;
            that.marker.setPosition([lng, lat]);
            that.map.add(that.marker);
            geocoder.getAddress(e.lnglat, function (status, result) {
              if (status === "complete" && result.regeocode) {
                const { formattedAddress } = result.regeocode;
                console.log("选中：", result.regeocode);
                that.form = {
                  location: formattedAddress,
                  lng: lng,
                  lat: lat,
                };
              }
            });
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleSearch(query) {
      if (!query) return;
      const that = this;
      that.loading = true;
      that.placeSearch.search(query, (status, result) => {
        that.loading = false;
        console.log(query, result);
        if (status === "complete") {
          that.options = result.poiList.pois;
        }
      });
    },
    handleSelect(item) {
      const { location, name, address } = item;

      const lng = location.lng;
      const lat = location.lat;

      console.log("选中：", name, address, lng, lat);
      this.form = {
        location: address,
        lng: lng,
        lat: lat,
      };
      this.marker.setPosition([lng, lat]);
      this.map.add(this.marker);
      this.map.setCenter([lng, lat]);
    },
    handleConfirm() {
      this.$emit("confirm", this.form);
    },
  },
};
</script>

<style scoped>
.map-container {
  height: 600px;
}
.select {
  margin-bottom: 10px;
  display: flex;
  gap: 6px;
  align-items: center;
  width: 350px;
}
.map {
  width: 100%;
  height: 100%;
}
</style>
